import { useState } from 'react'
import {
  autoUpdate,
  flip,
  offset,
  shift,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from '@floating-ui/react'

import {
  CALENDAR_GRID_CARD_TRIGGER_OFFSET,
  CALENDAR_GRID_CARD_TRIGGER_ROLE,
  CALENDAR_GRID_CARD_TRIGGER_SHIFT_PADDING,
} from './useCalendarGridCardTrigger.constants'

export function useCalendarGridCardTrigger({ placement }) {
  const [isOpen, setOpen] = useState(false)

  const { context, floatingStyles, refs } = useFloating({
    middleware: [
      offset(CALENDAR_GRID_CARD_TRIGGER_OFFSET),
      flip(),
      shift({ padding: CALENDAR_GRID_CARD_TRIGGER_SHIFT_PADDING }),
    ],
    open: isOpen,
    placement,
    whileElementsMounted: autoUpdate,
    onOpenChange: setOpen,
  })

  const click = useClick(context)
  const dismiss = useDismiss(context)
  const role = useRole(context, { role: CALENDAR_GRID_CARD_TRIGGER_ROLE })

  const { getFloatingProps, getReferenceProps } = useInteractions([
    click,
    dismiss,
    role,
  ])

  function handleClose() {
    setOpen(false)
  }

  return {
    context,
    floatingStyles,
    getFloatingProps,
    getReferenceProps,
    handleClose,
    isOpen,
    refs,
  }
}
